var _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgCable = function SvgCable(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#494949",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3.916v11.887c0 1.1.89 1.986 1.988 1.986h24.024A1.986 1.986 0 0 0 30 15.803V3.916c0-1.1-.89-1.986-1.988-1.986H3.988A1.986 1.986 0 0 0 2 3.916Zm-1.333 0A3.313 3.313 0 0 1 3.988.608h24.024a3.312 3.312 0 0 1 3.321 3.308v11.887a3.313 3.313 0 0 1-3.321 3.308H3.988a3.312 3.312 0 0 1-3.321-3.308V3.916Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.128 7.924h1.39c.323 0 .488-.222.488-.461 0-.249-.165-.465-.488-.465H9.653c-.323 0-.496.216-.496.465 0 .24.173.46.496.46h1.381v4.68c0 .403.246.583.547.583.296 0 .547-.18.547-.582v-4.68Zm6.62 3.98h-.054l-1.436-4.387c-.123-.406-.319-.542-.583-.542-.246 0-.552.154-.552.506 0 .086.023.24.092.434l1.608 4.517c.155.46.392.754.893.754.502 0 .72-.293.875-.754l1.623-4.558c.06-.176.077-.316.077-.411 0-.325-.282-.488-.547-.488-.264 0-.45.127-.578.547l-1.418 4.381Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 19.1h-5.334v2.654h5.334V19.1ZM20 18.12v3.634c0 .73-.597 1.322-1.333 1.322h-5.334A1.328 1.328 0 0 1 12 21.754V18.12h8Z",
    fillRule: "nonzero"
  }))));
};

export { SvgCable as ReactComponent };
export default "/_next/static/media/cable.3eeb474c.svg";